module.exports = __webpack_public_path__ + "img/BMW-logo.81731c21.png";